/**
 * Endpoint audit_log — backend REAL con hash chain.
 *
 * GET /api/audit-log    → listado paginable con filtros.
 * GET /api/audit-log/verify → verifica el chain (caro, on-demand).
 */

import {
  GetAuditEntriesResponseSchema,
  VerifyChainResponseSchema,
  type AuditEntry,
  type VerifyChainResponse,
} from '@/api/contracts/audit-log';
import { apiFetch } from '@/api/http';

export interface AuditEntriesFilters {
  action?: string;
  userId?: number;
  glnId?: number;
  from?: string;
  to?: string;
  limit?: number;
  offset?: number;
}

export async function getAuditEntries(
  filters: AuditEntriesFilters = {},
): Promise<{ entries: AuditEntry[]; limit: number; offset: number }> {
  const params = new URLSearchParams();
  if (filters.action) params.set('action', filters.action);
  if (filters.userId != null) params.set('userId', String(filters.userId));
  if (filters.glnId != null) params.set('glnId', String(filters.glnId));
  if (filters.from) params.set('from', filters.from);
  if (filters.to) params.set('to', filters.to);
  if (filters.limit != null) params.set('limit', String(filters.limit));
  if (filters.offset != null) params.set('offset', String(filters.offset));

  const qs = params.toString();
  const data = await apiFetch<unknown>(`/audit-log${qs ? `?${qs}` : ''}`, { auth: true });
  return GetAuditEntriesResponseSchema.parse(data);
}

export async function verifyAuditChain(): Promise<VerifyChainResponse> {
  const data = await apiFetch<unknown>('/audit-log/verify', { auth: true });
  return VerifyChainResponseSchema.parse(data);
}
